import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    // Free-entry mode: lets the visitor type values that are not in the option
    // list (the wish form's skills/industries have no canonical list to offer).
    // Off by default — the job form's selects must stay restricted to their
    // collections.
    create: Boolean,
    createLabel: String
  }

  async connect () {
    const { default: TomSelect } = await import('tom-select')
    const blankOption = this.element.querySelector('option[value=""]')
    this.selectInstance = new TomSelect(this.element, {
      plugins: ['remove_button', 'clear_button'],
      hidePlaceholder: true,
      create: this.createValue,
      // Without this a tag that was typed but not confirmed with Enter is
      // silently discarded the moment the visitor clicks the submit button.
      createOnBlur: this.createValue,
      // TomSelect only reads `placeholder` off the element attribute, which a
      // <select> does not have — surface the include_blank prompt instead.
      placeholder: blankOption?.textContent || undefined,
      render: this.createValue
        ? {
            option_create: (data, escape) =>
              `<div class="create">${escape(this.createLabelValue || 'Add')} <strong>${escape(data.input)}</strong>&hellip;</div>`
          }
        : {}
    })
    // setValues may have been called before this async import resolved; apply now.
    if (this.pendingValues) {
      this.selectInstance.setValue(this.pendingValues, false)
      this.pendingValues = null
    }
  }

  setValues (ids) {
    if (!Array.isArray(ids)) return

    const values = ids.map(String)
    if (this.selectInstance) {
      this.selectInstance.setValue(values, false)
    } else {
      // TomSelect hasn't mounted yet — apply once connect() finishes.
      this.pendingValues = values
    }
  }

  disconnect () {
    this.selectInstance?.destroy()
  }
}
